<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center">
        <h2 mat-dialog-title class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color">{{whatToSend.title}}</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center" mat-dialog-close>
        <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
    <div class="w-full text-black-color">
        <img src="assets/images/ui/img_what_send.png" alt="">

        <h3 class="text-2xl mt-4 mb-2 font-semibold">{{whatToSend.okToDeliver}}</h3>

        <p class="text-lg">{{whatToSend.desc_1}} <a
                [href]="'http://www.parcelsplease.co.uk/the-not-so-small-print/terms-and-conditions-of-carriage/'"
                target="_blank" class="text-blue-dark">{{whatToSend.desc_2}}</a> {{whatToSend.desc_3}}
            {{whatToSend.desc_4}}</p>
        <hr class="text-gray-color mt-4">

        <h4 class="text-xl font-semibold mt-4 mb-2">{{whatToSend.prohabit}}</h4>
        <ul class="listing pl-6">
            <li>{{whatToSend.point_1}}</li>
            <li>{{whatToSend.point_2}}</li>
            <li>{{whatToSend.point_3}}</li>
            <li>{{whatToSend.point_4}}</li>
            <li>{{whatToSend.point_5}}</li>
            <li>{{whatToSend.point_6}}</li>
            <li>{{whatToSend.point_7}}</li>
            <li>{{whatToSend.point_8}}</li>
            <li>{{whatToSend.point_9}}</li>
            <li>{{whatToSend.point_10}}</li>
            <li>{{whatToSend.point_11}}</li>
        </ul>

        <h4 class="text-xl font-semibold mt-4 mb-2">{{whatToSend.protection}}</h4>
        <p class="text-lg">The following items (or any item similar in description or content) can only be carried on a
            no-protection basis on any service.</p>
        <p class="text-lg mb-2">Any person sending such an item does so at their own risk:</p>
        <ul class="listing pl-6">
            <li>{{whatToSend.item_1}}</li>
            <li>{{whatToSend.item_2}}</li>
            <li>{{whatToSend.item_3}}</li>
            <li>{{whatToSend.item_4}}</li>
            <li>{{whatToSend.item_5}}</li>
        </ul>

        <h4 class="text-xl font-semibold mt-4 mb-2">{{whatToSend.loss}}</h4>
        <p class="text-lg">{{whatToSend.lossText}}</p>
        <ul class="listing pl-6">
            <li>{{whatToSend.loss_1}}</li>
            <li>{{whatToSend.loss_2}}</li>
            <li>{{whatToSend.loss_3}}</li>
            <li>{{whatToSend.loss_4}}</li>
            <li>{{whatToSend.loss_4}}</li>
            <li>{{whatToSend.loss_5}}</li>
            <li>{{whatToSend.loss_6}}</li>
            <li>{{whatToSend.loss_8}}</li>
        </ul>

        <h4 class="text-2xl font-semibold mt-4 mb-2">{{whatToSend.contactInformationHeader}}</h4>
        <h4 class="text-lg font-semibold mt-4 mb-2">{{whatToSend.contactInformation_1}}</h4>
        <p class="text-lg">{{whatToSend.contactInformation_2}}</p>

        <h4 class="text-lg font-semibold mt-4 mb-2">{{whatToSend.limitation}}</h4>
        <ul class="listing pl-6">
            <li><b>{{whatToSend.limitation_1}} </b>{{whatToSend.limitation_1A}}</li>
            <li><b>{{whatToSend.limitation_2}} </b>{{whatToSend.limitation_2A}}</li>
            <li><b>{{whatToSend.limitation_3}} </b>{{whatToSend.limitation_3A}}</li>
            <li><b>{{whatToSend.limitation_4}} </b>{{whatToSend.limitation_4A}}</li>
            <li><b>{{whatToSend.limitation_5}} </b>{{whatToSend.limitation_5A}}</li>
        </ul>

        <h4 class="text-xl font-semibold mt-4 mb-2">{{whatToSend.indemnification}}</h4>
        <p class="text-lg">{{whatToSend.indemnification_1}}</p>

        <h4 class="text-xl font-semibold mt-4 mb-2">{{whatToSend.governing}}</h4>
        <p class="text-lg">{{whatToSend.governing_1}}</p>

        <h4 class="text-xl font-semibold mt-4 mb-2">{{whatToSend.miscellaneous}}</h4>
        <p class="text-lg">{{whatToSend.miscellaneous_1}}</p>

        <h4 class="text-2xl font-semibold mt-4 mb-2">{{whatToSend.contactInformation}}</h4>
        <p class="text-lg">{{whatToSend.Note}}</p>

    </div>
</mat-dialog-content>